import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "container-fluid px-5 py-4" }
const _hoisted_2 = { class: "row justify-content-center" }
const _hoisted_3 = { class: "col-12 col-lg-8" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h1", { class: "mb-3" }, "Subscription payment", -1)
const _hoisted_5 = {
  key: 0,
  class: "alert alert-danger"
}
const _hoisted_6 = { class: "mt-3" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Back to subscription ")
const _hoisted_8 = {
  key: 1,
  class: "card shadow-sm"
}
const _hoisted_9 = { class: "card-body text-center py-5" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", {
  class: "fa fa-spin fa-spinner fa-2x mb-3 d-block",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_11 = { class: "mb-0 text-muted" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        (_ctx.error)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createTextVNode(_toDisplayString(_ctx.error) + " ", 1),
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_router_link, {
                  to: { name: 'subscription-upgrade' },
                  class: "btn btn-outline-secondary"
                }, {
                  default: _withCtx(() => [
                    _hoisted_7
                  ]),
                  _: 1
                })
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _hoisted_10,
                _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.statusMessage), 1)
              ])
            ]))
      ])
    ])
  ]))
}